<div class="container mt-4 mb-5">
  <h4 i18n>Minha conta</h4>
  <div class="row">
    <div class="col-lg-3 mt-3 mb-3">
      <div class="gcc-menudrop dropdown-menu">
        <a
        i18n
          routerLink="/meus-dados"
          [queryParams]="{ list: 1 }"
          routerLinkActive="active"
          [class.active]="list == 1"
          class="dropdown-item"
          >Meus Boletos</a
        >
        <a
        i18n
          routerLink="/meus-dados"
          [queryParams]="{ list: 2 }"
          routerLinkActive="active"
          class="dropdown-item"
          >Meus Dados</a
        >
        <a
        i18n
          routerLink="/meus-dados"
          [queryParams]="{ list: 3 }"
          routerLinkActive="active"
          class="dropdown-item"
          >Alterar Senha</a
        >
      </div>
    </div>
    <div class="col-lg-9">
      <div *ngIf="list == 1">
        <!--div class="alert alert-warning alert-dismissible fade show mb-2" role="alert">
                    <strong>Evite problemas:</strong> Não page o boleto duas vezes.
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="alert alert-info alert-dismissible fade show mb-2" role="alert">
                    O pagamento pode levar de 1 até 3 dias úteis para ser reconhecido!
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>-->

        <div
          *ngIf="empty"
          class="alert alert-success alert-dismissible fade show"
          role="alert"
          i18n
        >
          Nenhum boleto encontrado!
          <button
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div *ngIf="!empty" class="mt-2 mb-3">
          <div class="row">
            <div class="col-md-6 pl-0">
              <div class="form-group">
                <label i18n>Sacado</label>
                <select
                  name="sacado"
                  (change)="mudaSacado($event)"
                  class="form-control"
                >
                  <option value="">...</option>
                  <option *ngFor="let s of arrSacado" value="{{ s }}">
                    {{ s }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <table
              class="table table-hover table-condensed table-responsive-md"
            >
              <thead>
                <tr>
                  <th i18n scope="col">Sacado</th>
                  <th i18n scope="col">Número</th>
                  <th i18n scope="col">Documento</th>
                  <th i18n scope="col">Vencimento</th>
                  <th i18n scope="col">R$ Valor</th>
                  <th i18n scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let b of boletos">
                  <td>{{ b.sacadoNome }}</td>
                  <td>{{ b.nossoNumero }}</td>
                  <td>{{ b.numeroDocumento }}</td>
                  <td>{{ b.dataVencimento | dateBRA }}</td>
                  <td class="money-green">
                    {{ b.valorBoleto | currency : "BRL" : "" }}
                  </td>
                  <td class="text-center align-middle">
                    <button
                      (click)="printBoletoPdf(b)"
                      data-toggle="modal"
                      data-target="#boletoModal"
                      title="Mostrar Boleto"
                      class="btn btn-outline-primary"
                    >
                      <i class="icofont-search-document"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row">
            <div class="col-lg-12 text-right pr-0">
              <label i18n>{{ boletos.length }} registros encontrados</label>
            </div>
          </div>
        </div>
        <!-- Modal Boleto -->
        <div
          class="modal fade"
          id="boletoModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="boletoModalLabel"
          aria-hidden="true"
        >
          <div
            class="modal-dialog modal-dialog-centered modal-lg"
            role="document"
          >
            <div *ngIf="boletoSelected" class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">
                  {{ boletoSelected.lancamento }} -
                  {{ boletoSelected.numeroDocumento }}
                </h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body"></div>
            </div>
          </div>
        </div>
        <!-- Fim Modal Novo Endereço -->
      </div>
      <div *ngIf="list == 2">
        <p>Informações da sua conta</p>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label>Código</label><br />
              {{ initProvider.usuario.id }}
            </div>
            <div class="form-group">
              <label>Nome</label><br />
              {{ initProvider.usuario.nome }}
            </div>
            <div class="form-group">
              <label>Login</label><br />
              {{ initProvider.usuario.login }}
            </div>
            <div class="form-group">
              <label>Tipo</label><br />
              {{ initProvider.usuario.tipo }}
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="list == 3">
        <p>Informe a senha antiga para alterar</p>
        <div *ngIf="errorPassword" class="alert alert-primary" role="alert">
          {{ errorMsgPassword }}
        </div>
        <form (ngSubmit)="onSubmitPassword()" [formGroup]="formPassword">
          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <label>Senha antiga</label>
                <input
                  formControlName="senhaAntiga"
                  name="senhaAntiga"
                  type="password"
                  class="form-control"
                />
                <div
                  *ngIf="
                    errorPassword && formPassword.get('senhaAntiga').invalid
                  "
                  class="error"
                >
                  Verifique este campo!
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <label>Nova senha</label>
                <input
                  formControlName="senhaNova"
                  name="senhaNova"
                  type="password"
                  class="form-control"
                />
                <div
                  *ngIf="errorPassword && formPassword.get('senhaNova').invalid"
                  class="error"
                >
                  Verifique este campo!
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <label>Confirmar nova senha</label>
                <input
                  formControlName="senhaNovaConfirm"
                  name="senhaNovaConfirm"
                  type="password"
                  class="form-control"
                />
                <div
                  *ngIf="
                    errorPassword &&
                    formPassword.get('senhaNovaConfirm').invalid
                  "
                  class="error"
                >
                  Verifique este campo!
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              <button class="btn btn-primary">Alterar</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
